import { Radio } from "antd";
import classNames from "classnames";
import { useState } from "react";
import Label from "../../Label";

const Simple = ({
  errors,
  touched,
  label,
  icon,
  iconLabel,
  onChange,
  values = [],
  value,
  required,
  subLabel,
  size,
  row = false,
  ...rest
}) => {
  const [checkedValue, setCheckedValue] = useState(value);
  const onSelect = (e) => {
    setCheckedValue(e.target.value);
    onChange(e.target.value);
  };
  return (
    <div
      className={classNames("radio-btn__wrapper", size, {
        "radio-btn__wrapper--error": touched && errors,
      })}
    >
      <Label label={label} icon={iconLabel} required={required} />
      <div className={`mutualMobility-radio--field`}>
        <Radio.Group
          onChange={onSelect}
          value={checkedValue}
          defaultValue={value}
          className={classNames({ row })}
          {...rest}
        >
          {values.map(({ label, icon, value: _value }) => (
            <Radio
              key={`radio.${_value}`}
              value={_value}
              className={`${_value === checkedValue && "checked"}`}
            >
              <div className="radio-btn__wrapper--content">
                {icon && icon}
                <span className="--label"> {label}</span>
              </div>
            </Radio>
          ))}
        </Radio.Group>
        {touched && errors && <p className={"input--errors"}>{errors}</p>}
      </div>
    </div>
  );
};

export default Simple;
